import React from 'react';

function NotRegistered() {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', flexDirection: 'column', padding: '24px', textAlign: 'center', boxSizing: 'border-box', overflow: 'hidden' }}>
            <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#3C96D4', marginBottom: '12px' }}>MOMENT</div>
            <div style={{ maxWidth: '640px' }}>
                <h2 style={{ margin: '0 0 12px 0' }}>You're not registered on Moment yet</h2>
                <p style={{ margin: '0 0 12px 0' }}>
                    We couldn't find your account in our system. Please contact an administrator to register your user so you can access Moment.
                </p>
                <p style={{ margin: '0 0 12px 0', color: '#555' }}>
                    If you believe this is a mistake, try signing out and signing back in, or reach out to IT support.
                </p>
            </div>
        </div>
    );
}

export default NotRegistered;


